<app-main-page>
  <app-sales-list></app-sales-list>
</app-main-page>
